import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_rrcv7ypjg9: FaireCollectionEntity = {
  token: "pbc_rrcv7ypjg9",
  type: "collection",
  name: "notecards",
  heroImageUrl:
    "https://cdn.faire.com/fastly/804019b69c6b3513101d3ab13569c63d19123a68c80002c109e6b8cd3878927b.jpeg",
  itemCount: 42,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.558Z",
    importedBy: "entity-db-import-collections",
  },
};
